import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'easternMoment',
})
export class EasternMomemtPipe implements PipeTransform {
  transform(value): any {
    if (!value) {
      return null;
    }
    return moment.utc(value).tz('America/New_York');
  }
}
